// NOTE: This has a dependency on /aptitude/js/importWorker.js
export default class FileParserService {
  constructor(private $q) {
    'ngInject';
  }

  /**
   * Get the first X rows from a spreadsheet file
   *
   * @param  {[type]}           file
   * @return {ng.IPromise<any>}
   */
  getFirstRowsFromFile(file, worker): ng.IPromise<any> {
    let d = this.$q.defer();

    this.readFileWithWorker(
      file.data,
      {
        name: 'getFirstRows',
        params: {
          numRows: 15
        }
      },
      worker
    )
      .then((worksheets) => {
        d.resolve({
          file,
          worksheets
        });
      })
      .catch((error) => {
        if (error.message.indexOf('Unsupported file') !== -1) {
          d.reject('Invalid file format');
        } else {
          d.reject('Could not read file');
        }
      });

    return d.promise;
  }

  readFileWithWorker(file, workerMethod, worker) {
    let d = this.$q.defer();

    if (typeof Worker === 'undefined' || typeof FileReader === 'undefined') {
      d.reject({
        error: true,
        message: 'Your browser is not supported. Please upgrade.'
      });
    }

    let reader = new FileReader();

    let onload = (onloadEvent) => {
      let fileContents = onloadEvent.target.result;

      fileContents = new Uint8Array(fileContents);

      worker.onmessage = (workerEvent) => {
        if (workerEvent.data) {
          if (workerEvent.data.data) {
            d.resolve(JSON.parse(workerEvent.data.data));
          }
        }
      };

      worker.onerror = (errorEvent) => {
        // errorEvent.preventDefault();
        d.reject(errorEvent);
      };

      worker.postMessage({
        method: workerMethod,
        data: fileContents,
        binary: 'array'
      });
    };

    reader.onload = onload;

    // Reading as a binary string takes roughly twice as long as reading as an array buffer, so just use array
    reader.readAsArrayBuffer(file);

    return d.promise;
  }
}
